import React, { useEffect, useState } from "react";
import "./Sidebar.scss";
import { useDispatch, useSelector } from "react-redux";
import { setloggedIn } from "../../../store/slices/userSlice.js";
import { SidebarData } from "./sidebarData/SideabrData.jsx";
import { IBSidebarData } from "./sidebarData/IBSidebarData.jsx";
import { useNavigate, useLocation } from "react-router-dom";
import { Sidebar, Menu, SubMenu } from "react-pro-sidebar";
import ConfirmationModal from "../../modals/ConfirmationModal.jsx";
import { LogoutApi, ClearNotificationApi, GetNotificationApi } from "../../../api/request/users.js";
import toast from "react-hot-toast";
import { removeCookies } from "../../../services/Cookies.jsx";
import { Avatar, Badge, Drawer } from "antd";
import Profile from "../../../pages/user/profile/Profile.jsx";
import Notifications from "../notifications/Notifications.jsx";
import Bellicon from "../../../assets/Bellicon.jsx";
import * as signalR from "@microsoft/signalr";
import { Cookies } from "react-cookie";
import { IpProvider } from "../../../services/IpProvider.js";

export default function AppSidebar({ ib }) {
     const navigate = useNavigate();
     const dispatch = useDispatch();
     const cookies = new Cookies();
     const { token } = cookies.getAll();
     const [isKycCompleted, setIsKycCompleted] = useState(false);
     const [isClientVerify, setClientVerify] = useState(true)
     const { userDetails } = useSelector((state) => state.user);
     const { pathname } = useLocation();
     const [isLoading, setIsLoading] = useState(false);
     const [isModalOpen, setIsModalOpen] = useState(false);
     const [isDrawerOpen, setIsDrawerOpen] = useState(false);
     const [isNotification, setIsNotification] = useState(false);
     const [notifications, setNotifications] = useState({ isReadCount: 0, unReadCount: 0, totalMessageCount: 0, details: [] });
     const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);
     const [isfetchNotification, setIsFetchNotification] = useState(false);
     const [connection, setConnection] = useState("");
     const [ipAddress, setIpAddress] = useState("");

     const filteredSidebarData = () => {
          return (ib ? IBSidebarData : SidebarData).filter((item) => {
               if (item.title === "Perent Tree" && !userDetails.isShowParentTree) {
                    return false;
               }
               return true;
          });
     };

     const initializeSignalRConnection = () => {
          try {
               if (!connection) {
                    const newConnection = new signalR.HubConnectionBuilder()
                         .withUrl(`${process.env.REACT_APP_BASE_URL.replace(/\/api\/?$/, "")}/chathub`, { accessTokenFactory: () => token })
                         .withAutomaticReconnect()
                         .build();

                    setConnection(newConnection);
               }
          } catch (error) {

          }
     };

     useEffect(() => {
          if (isfetchNotification) {
               initializeSignalRConnection();
          }
     }, [isfetchNotification]);

     useEffect(() => {
          if (connection) {
               connection
                    .start()
                    .then(() => {
                    })
                    .catch((err) => console.error(err.toString()));

               connection.on("ReceiveMessage", (data) => {
                    setNotifications((prevState) => ({
                         ...prevState,
                         isReadCount: prevState.isReadCount,
                         unReadCount: prevState.unReadCount + 1,
                         totalMessageCount: prevState.totalMessageCount + 1,
                         details: prevState?.details?.length ? [...prevState?.details, data] : [data],
                    }));
               });
          }
     }, [connection]);

     const getNotification = async () => {
          try {
               const { data } = await GetNotificationApi();
               if (data?.success) {
                    setNotifications(data?.data);
               }
               setIsFetchNotification(true);
          } catch (error) {
               setIsFetchNotification(true);
          }
     };

     const handleMenuClick = (index) => {
          setOpenSubMenuIndex(index);
     };

     const getIpAddress = async () => {
          try {
               const { data } = await IpProvider();
               setIpAddress(data?.ip);
          } catch (error) { }
     };

     useEffect(() => {
          if (userDetails?.kycStatus === true) {
               setIsKycCompleted(true);
          }
          if (userDetails?.clientVerify === true) {
               setClientVerify(true)
          }
          getIpAddress();
     }, []);

     useEffect(() => {
          if (isNotification) getNotification();
     }, [isNotification])
     
     useEffect(() => {
          getNotification();
     }, [])

     const getFirstPath = (path) => {
          const parts = path.split("/");
          if (ib) {
               return parts.length > 1 ? "/" + parts[1] + "/" + parts[2] : path;
          } else {
               return parts.length > 1 ? "/" + parts[1] : path;
          }
     };

     const isActivePath = (path) => {
          let active = false;
          path?.map((item) => {
               if (item == getFirstPath(pathname)) {
                    active = true;
               }
          });
          return active;
     };

     const logoutHandler = async () => {
          try {
               setIsLoading(true);
               const { data } = await LogoutApi({ ipAddress });
               if (data?.success) {
                    toast.success(data?.message);
               }
               localStorage.clear();
               dispatch(setloggedIn(false));
               removeCookies("token");
               navigate("/");
               setIsModalOpen(false);
               setIsLoading(false);
          } catch (err) {
               dispatch(setloggedIn(false));
               removeCookies("token");
               navigate("/");
               setIsModalOpen(false);
               setIsLoading(false);
          }
     };

     const clearNotifications = async () => {
          const { data } = await ClearNotificationApi();
          if (data.success) {
               setNotifications({ isReadCount: 0, unReadCount: 0, totalMessageCount: 0, details: [] });
               toast.success(data.message);
          }
     };

     return (
          <div className="sidebar-container w-[250px] fixed">
               <div className="h-[75px] border-b border-gray-200 p-4">
                    <div className="h-full w-full flex items-center justify-between">
                         <img className="h-[60px]" src="/assets/logo/logo.png" alt="logo" />
                         <div className="cursor-pointer" onClick={() => setIsNotification(true)}>
                              <Badge count={notifications?.unReadCount || 0} overflowCount={5}>
                                   <Bellicon />
                              </Badge>
                         </div>
                    </div>
               </div>

               <div className={`h-[calc(100vh-${userDetails.kycStatus ? "150px" : "186px"})] overflow-y-auto pl-4`}>
                    {filteredSidebarData().map((item, index) => {
                         const iconWithProps = item?.icon
                              ? React.cloneElement(item?.icon, { active: isActivePath(item?.activeUrl) })
                              : null;
                         return item?.child ? (
                              <Sidebar key={index}>
                                   <Menu>
                                        <SubMenu
                                             key={index}
                                             open={openSubMenuIndex === index}
                                             onOpenChange={() => handleMenuClick(index === openSubMenuIndex ? null : index)}
                                             // disabled={item.title === "Create profile" ? false : !isClientVerify}
                                             disabled={(!isKycCompleted && item?.kycApproval)}
                                             label={
                                                  <button
                                                       key={index}
                                                       className={`flex items-center text-[#2F2B3DB2] font-medium cursor-pointer py-2 px-6 header`}
                                                  >
                                                       {iconWithProps}
                                                       <p className="text-base ms-3">{item?.title}</p>
                                                  </button>
                                             }
                                        >
                                             <div className="pt-1">
                                                  {item?.child?.map((childItem, childIndex) => {
                                                       const childIconWithProps = childItem?.icon
                                                            ? React.cloneElement(childItem?.icon, {
                                                                 active: isActivePath(childItem?.activeUrl),
                                                            })
                                                            : null;
                                                       return (
                                                            <div
                                                                 key={childIndex}
                                                                 onClick={() => navigate(childItem?.url)}
                                                                 className={`submenu child flex items-center text-[#2F2B3DB2] rounded-lg cursor-pointer font-medium py-2 ms-5 ps-4 pe-6 mr-4 duration-200 ${index != 0 ? "mt-1" : null
                                                                      } ${isActivePath(childItem?.activeUrl)
                                                                           ? "active_icon primary text-white font-semibold"
                                                                           : null
                                                                      }`}
                                                            >
                                                                 {childIconWithProps}
                                                                 <p className="text-base ms-3">{childItem?.title}</p>
                                                            </div>
                                                       );
                                                  })}
                                             </div>
                                        </SubMenu>
                                   </Menu>
                              </Sidebar>
                         ) : (

                              <div
                                   key={index}
                                   onClick={() => navigate(item?.url)}
                                   className={`${(isKycCompleted && isClientVerify && item?.unAuth) || (isClientVerify && item?.title === "Client Profile") ? "hidden" : ""
                                        } text-[#2F2B3DB2] font-medium rounded-lg cursor-pointer my-3 mr-4 duration-200 ${isActivePath(item?.activeUrl) ? "shadow-inner bg-primary text-white font-semibold" : null
                                        }`}
                              >
                                   <button
                                        className="flex items-center w-full py-2 px-6"
                                        onClick={() => handleMenuClick(index)}
                                        // disabled={item.title === "Client Profile" ? false : !isClientVerify}
                                        disabled={(!isKycCompleted && item?.kycApproval)}
                                   >
                                        {iconWithProps}
                                        <p className="text-base ms-3">{item?.title}</p>
                                   </button>
                              </div>
                         );
                    })}
               </div>

               <div className="h-[75px] p-4">
                    <div className="flex items-center justify-between gap-5 cursor-pointer">
                         <div className="flex items-center gap-3"  onClick={() => navigate('/profile')}>
                              <Avatar size={46} className="uppercase bg-primary" src={userDetails?.profileImagePath}>
                                   {userDetails?.firstName?.charAt(0)}
                                   {userDetails?.lastName?.charAt(0)}
                              </Avatar>
                              <div>
                                   <p className="font-semibold text-base line-clamp-1 capitalize">{userDetails?.firstName} {userDetails?.lastName}</p>
                                   <p className="text-sm primary">{userDetails?.role} Account</p>
                              </div>
                         </div>
                         <button
                              className="text-red-600"
                              onClick={() => setIsModalOpen(true)}
                         >
                              <img src="/assets/icons/logout.svg" className="h-5" alt="icon" />
                              {/* <p>Logout</p> */}
                         </button>
                    </div>
               </div>

               {/* --- Logout confirmation modal --- */}
               <ConfirmationModal
                    isOpen={isModalOpen}
                    setIsOpen={setIsModalOpen}
                    message="Are you sure you want to logout?"
                    onConfirm={logoutHandler}
                    isLoading={isLoading}
                    loadingLabel="Logging out..."
               />

               {/* --- User profile drawer --- */}
               <Drawer
                    title={
                         <div className="flex justify-between items-center">
                              <p>Profile</p>
                              <button
                                   className="text-sm text-red-600 font-semibold px-6 py-2 flex items-center gap-3"
                                   onClick={() => setIsModalOpen(true)}
                              >
                                   <img src="/assets/icons/logout.svg" className="h-5" alt="icon" />
                                   <p>Logout</p>
                              </button>
                         </div>
                    }
                    onClose={() => setIsDrawerOpen(false)}
                    width={600}
                    open={isDrawerOpen}
               >
                    <Profile isDrawer={isDrawerOpen} />
               </Drawer>

               {/* --- Notification drawer --- */}
               <Drawer
                    title={
                         <div className="flex justify-between items-center">
                              <p>Notification</p>
                              <p className="cursor-pointer" onClick={clearNotifications}>
                                   Clear all
                              </p>
                         </div>
                    }
                    onClose={() => setIsNotification(false)}
                    width={600}
                    open={isNotification}
               >
                    <Notifications notifications={notifications} getNotification={getNotification} />
               </Drawer>
          </div>
     );
}
